module.exports = {
          srcSet: __webpack_public_path__ + "47719aaa99c3c88fba42abc2a9afab42-801.png"+" 801w",
          images:[ {path: __webpack_public_path__ + "47719aaa99c3c88fba42abc2a9afab42-801.png",width: 801,height: 566}],
          src: __webpack_public_path__ + "47719aaa99c3c88fba42abc2a9afab42-801.png",
          toString:function(){return __webpack_public_path__ + "47719aaa99c3c88fba42abc2a9afab42-801.png"},
          
          width: 801,
          height: 566
        }